import React, { useEffect, useState, useCallback } from "react";
import { Score2 as Score } from "../../components/Score";

import "./SupervisorAppraisalListMain.css";
import StatusBall from "../../components/StatusBall";
import { get } from "axios";

const AppraisalListItemRow = (props) => {
  const [pic, setPic] = useState(false);
  const { record, row_no, onView, iam } = props;

  const { appraiser_doc, appraisal_doc, user_doc, appraisers } = record;
  const { fullname, userid } = user_doc;

  const status = appraisal_doc?.status;

  const getPhoto = useCallback((userid, isMounted, setPic2) => {
    get(
      "https://eleave.hslnet.my/apiv2/public/index.php/employeephoto/" + userid
    )
      .then((res) => {
        if (isMounted) {
          if (res.data !== "") {
            setPic2(res.data.photo);
          }
          else {
            setPic2("data:image/jpeg;base64,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");
          }
        }
      })
      .catch((e) => {});
  });
  useEffect(() => {
    let isMounted = true;

    getPhoto(userid, isMounted, setPic);

    return () => {
      isMounted = false;
    };
  }, [userid]);
  let nameClassName = "ten tableCellName tip  " + status;
  nameClassName = "ten tableCellName tip  ";
  const handleClick = () => {
    onView && onView(row_no, record);
  };

  return (
    <tr style={{ cursor: "pointer" }} onClick={handleClick}>
      <td>{row_no + 1}</td>
      <td className={nameClassName}>
        <div className="d-flex">
          <div className="me-2">
            {pic !== false && (
              <img
                alt="xx"
                src={pic}
                style={{ borderRadius: "50%", width: "3em" }}
              />
            )}
          </div>

          <div>
            <div className="d-flex flex-column">
              <div>
                <h4>
                  <StatusBall status={status} />
                  {fullname?.toUpperCase()}
                </h4>
                {iam === appraisers?.proxy?.userid && (
                  <span style={{ fontWeight: "100", fontSize: "small" }}>
                    delegated to you by {appraisers?.appraiser?.fullname?.toUpperCase()}
                  </span>
                )}
              </div>
              <div>
                {appraiser_doc && (
                  <span style={{ fontSize: "small" }}>
                    acessed by {appraiser_doc.fullname?.toUpperCase()}
                  </span>
                )}
                {/* 
                <span style={{ fontSize: "x-small", fontWeight: "100" }}>
                  {status && <span>( {status} )</span>}
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </td>
      {appraisal_doc === undefined && (
        <td colSpan={9}>
          Click here to fill Employee Annual Performance Evaluation
        </td>
      )}
      {appraisal_doc !== undefined && (
        <>
          <td className="five">
            <Score score={appraisal_doc.workQuality} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.workEfficiency} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.jobKnowledge} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.communicationSkills} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.interpersonalSkills} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.isoQualityManagementSystem} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.attendance} />
          </td>
          <td className="five">
            <Score score={appraisal_doc.supervisorySkills} />
          </td>

          <td className="total">
            {" "}
            <Score score={appraisal_doc.totalScore} />
          </td>
        </>
      )}
    </tr>
  );
};
export default AppraisalListItemRow;
